import Rest from './base/Rest';

export default class OccurrencesService extends Rest {
  static resource = 'occurrences';
}
